<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <!-- <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="130px">
                    <el-row type="flex" justify="center">
                        <el-col :span="4">
                            <el-button @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
                            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
                        </el-col>
                    </el-row>
                </el-form> -->
      </div>
      <el-row class="action-btn-row">
      </el-row>
      <el-table :data="tableData" border highlight-current-row class="table" @selection-change="handleSelectionChange" ref="supplierSelectTabel">
        <el-table-column show-overflow-tooltip　prop="operationDate" :label="$t('common.OperationTime')"></el-table-column>
        <!--操作时间-->
        <el-table-column show-overflow-tooltip　prop="updateBy" :label="$t('common.OperatorName')"></el-table-column>
        <!--操作人-->
        <el-table-column show-overflow-tooltip　prop="fpaNo" :label="$t('material.fpaNo')"></el-table-column>
        <!--FPA编号-->
        <el-table-column show-overflow-tooltip　prop="newPricePerUom" :label="$t('material.newPricePerUom')"></el-table-column>
        <!--未来有效价格-->
        <el-table-column show-overflow-tooltip　prop="validFrom" :label="$t('material.PriceStartTime')"></el-table-column>
        <!--价格开始时间-->
        <el-table-column show-overflow-tooltip　prop="updateDate" :label="$t('material.FPAApprovalTime')"></el-table-column>
        <!--FPA审批通过时间-->
        <el-table-column show-overflow-tooltip　prop="operationStatusI18n" :label="$t('common.status')"></el-table-column>
        <!--状态-->
        <el-table-column show-overflow-tooltip　prop="manualAssignmentDate" :label="$t('material.manualAssignmentDate')"></el-table-column>
        <!--手工指定有效期-->
        <el-table-column show-overflow-tooltip　prop="mdmSynchronizationDate" :label="$t('material.mdmSynchronizationDate')"></el-table-column>
        <!--MDM同步日期-->
        <el-table-column show-overflow-tooltip　prop="remarks" :label="$t('common.remarks')"></el-table-column>
        <!--备注-->
        <el-table-column show-overflow-tooltip　:label="$t('common.attachment')">
          <template slot-scope="scope">
            <!-- <div class="a-link" @click="showFile(scope.row)">下载</div> -->
            <div class="a-link" @click="showFile(scope.row)" v-show="scope.row.isIssued=='disable' ">下载</div>
          </template>
        </el-table-column>
        <!--附件-->

      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="detailFormVisible" append-to-body width="30%" @close='closeDialog'>
      <el-table :data="fileList" border highlight-current-row class="table" v-if="detailFormReset">
        <el-table-column sortable prop="documentName" :label="$t('common.file')">
          <!--文件-->
          <template slot-scope="scope">
            <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column  prop="tmDocumentId" v-if="canSave">
                    <template slot-scope="scope">
                        <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,PDFlist)">{{$t('common.del')}}</el-link>
                    </template>
                </el-table-column> -->
      </el-table>
      <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="detailFormVisible = false">{{$t('common.close')}}</el-button>
            </span> -->
    </el-dialog>
  </div>
</template>
<script>
import { apiService } from "@/api/material/material-master-data";
import { fileService } from "@/api/common/file-utils";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";

export default {
  components: { IcSelect },
  props: {
    multipleSelectionFlag: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
    },
    tmMaterialId: {
      type: String,
    },
  },
  data() {
    var checkFile = (rule, value, callback) => {
      if (this.fileList.length < 1) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    return {
      issuePriceTakeEffectDateDialog: false,
      detailFormReset: false,
      issuePriceTakeEffectDateForm: {
        issuePriceTakeEffectDate: '',
      },
      issuePriceTakeEffectDaterules: {
        issuePriceTakeEffectDate: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
      },
      fileList: [],
      tsRecId: '',
      tableData: [],
      totalCount: 0,
      statusList: [], // 状态列表
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
      },
      disableDialog: false,
      disableForm: {},
      disableRules: {
        remarks: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }],
        // uploadFile:[{ required: true, trigger: ["change"],validator: checkFile  }],
        uploadFile: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
      },
      multipleSelection: [],
      supplierStatusList: [],
      getRowKeys(row) {
        return row.tmSupplierId;
      },
      selectRows: [],
      categoryList1: [],
      categoryList2: [],
      radioVal: null,
      AgreementPickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.validFromEnd;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      AgreementPickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.validFrom;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
      issueTimePickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.issueEndTime;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      issueTimePickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.issueTime;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    }
  },
  created() {
    this.queryData(1);
  },
  watch: {
    // visible() {
    //     this.$refs.supplierSelectTabel.clearSelection();
    // }
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      this.queryCondition.tmMaterialId = this.tmMaterialId

      apiService.findLogPage(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      })
    },
    clickSelectMethod: function () {
      this.$emit('subCallMethod', this.selectRows);
      // if(this.selectRows.length==0){
      //     this.$message({message: "请选供应商", type: "warning"});
      // }else{
      //     this.$emit('subCallMethod', this.selectRows);
      // }
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRows.push(row);
          }
        });
      }
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);

    },
    showFile(row) {
      let that = this
      let attachment = {};
      that.detailFormReset = false
      attachment.seq = '1';
      attachment.tsRecId = row.workFlowId;
      attachment.tsReckindId = 'MATERIAL_FPA';
      fileService.getFileList(attachment).then((fileRes) => {
        that.detailFormVisible = true
        that.$nextTick(() => {
          that.detailFormReset = true
        })
        that.fileList = fileRes;
      })
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    closeDialog() {
      this.detailFormVisible = false
      this.detailFormReset = false
    },
  },
  extends: commonFunction
}
</script>
<style scoped>
.el-select {
  width: 100%;
}
</style>
<style>
.disableForm .disableFormRemarks .el-form-item__content {
  width: 70%;
}
</style>
